import { Component, OnInit, ViewChild } from '@angular/core';
import { PermitDetailsModel, BusinessTypeItemModel, PermitDetailsItemModel } from '../services/permit.service';
import { PermitService } from '../services/permit.service';
import { ErrorHandlingService, FormValidationService, LocalParserFormatter, ValidationError } from 'core-lib';
import { GooglePlacesService, FormValidator, AlertService } from 'core-lib';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';
import { YesCancelModalComponent } from '../modals/yes-cancel-modal/yes-cancel-modal.component';


@Component({
  selector: 'cli-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit {

  public vm: AccountDetailsViewModel;
  public googlePlacesOptions: any;

  private validator: FormValidator;

  @ViewChild('sendValidationModal')
  public sendValidationModal: YesCancelModalComponent;

  constructor(private permitSvc: PermitService,
    private formValidationSvc: FormValidationService,
    private errorHandlingSvc: ErrorHandlingService,
    private router: Router,
    private alertSvc: AlertService,
    private formatter: LocalParserFormatter,
    private googlePlacesSvc: GooglePlacesService) {

    this.vm = new AccountDetailsViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);

    this.googlePlacesOptions =  this.googlePlacesSvc.defaultOptions;
  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);

      this.vm.isLoading = false;
      this.vm.isOpening = false;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  addPermitAdminMobileUser()
  {
      this.router.navigate(['app/user-accounts/new4']);  
  }

  validateEmail() {

      this.sendValidationModal.message = 'The system will send and email to the provided email address.<br/><br/>' +
        'You will need to click on the link in the email to complete the verification process<br/><br>' +
        'Do you wish to continue?';
     
      this.sendValidationModal.openModal().subscribe((r: string) => {

        if (r === 'Yes') {

          this.vm.isLoading = true;

          this.vm.isLoading = true;
          this.permitSvc.sendValidationEmail().toPromise().then((n)=>{
            this.alertSvc.success('Email Validation', 'The validation email was successfuly sent');
          },  (e) => { this.errorHandlingSvc.processHttpError(e); })
          .finally(() => { this.vm.isLoading = false; });     
        }

      }, (e) => { });   
  }

  mapModel(vm: AccountDetailsViewModel, data: PermitDetailsModel) {
    vm.permitId = data.permitDetails.permitId;
    vm.businessName = data.permitDetails.clientName;
    vm.firstName = data.permitDetails.firstName;
    vm.abn = data.permitDetails.abn;
    vm.lastName = data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;
    vm.startDate = this.formatter.toDate(this.formatter.fromIsoString(data.permitDetails.startDate));

    vm.clientName = data.permitDetails.clientName;
    vm.firstName = data.permitDetails.firstName;
    vm.lastName = data.permitDetails.lastName;

    vm.email = data.permitDetails.email;
    vm.isEmailValidated = data.permitDetails.isEmailValidated;
    vm.workPhone = data.permitDetails.workPhone;
    vm.mobilePhone = data.permitDetails.mobilePhone;

    vm.isSameAddress = data.permitDetails.isSameAddress;

    vm.address1 = data.permitDetails.address1;
    vm.address2 = data.permitDetails.address2;
    vm.suburb = data.permitDetails.suburb;
    vm.postCode = data.permitDetails.postCode;
    vm.state = data.permitDetails.state;
    vm.isAddressNotFound = data.permitDetails.isAddressNotFound;

    vm.billingAddress1 = data.permitDetails.billingAddress1;
    vm.billingAddress2 = data.permitDetails.billingAddress2;
    vm.billingSuburb = data.permitDetails.billingSuburb;
    vm.billingPostCode = data.permitDetails.billingPostCode;
    vm.billingState = data.permitDetails.billingState;
    vm.isBillingAddressNotFound = data.permitDetails.isBillingAddressNotFound;
    
    vm.businessTypeId = data.permitDetails.businessTypeId;
    vm.businessTypeOther = data.permitDetails.businessTypeOther;

    vm.businessTypes = _.map(data.businessTypes,
      (r: BusinessTypeItemModel) => {
        return {
          businessTypeId: r.businessTypeId,
          description: r.description
        };
      });

    vm.status = data.permitDetails.status;
    vm.expiryDate = this.formatter.toDate(this.formatter.fromIsoString(data.permitDetails.expiryDate));

    vm.emsKeys = _.map(data.permitDetails.emsKeys, (k) => { return k.emsNo; });
  }


  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public save() {

    this.updateBillingAddress();

    this.validate().then(() => {

      this.vm.isLoading = true;

      let data = new PermitDetailsItemModel();
      data.permitId = this.vm.permitId;
      data.abn = this.vm.abn;
      data.isSameAddress = this.vm.isSameAddress;

      data.clientName = this.vm.businessName;
      data.firstName = this.vm.firstName;
      data.lastName = this.vm.lastName;
      data.email = this.vm.email;

      data.workPhone = this.vm.workPhone;
      data.mobilePhone = this.vm.mobilePhone;

      data.address1 = this.vm.address1;
      data.address2 = this.vm.address2;
      data.suburb = this.vm.suburb;
      data.postCode = this.vm.postCode;
      data.state = this.vm.state;
      data.isAddressNotFound = this.vm.isAddressNotFound;

      data.billingAddress1 = this.vm.billingAddress1;
      data.billingAddress2 = this.vm.billingAddress2;
      data.billingSuburb = this.vm.billingSuburb;
      data.billingPostCode = this.vm.billingPostCode;
      data.billingState = this.vm.billingState;
      data.isBillingAddressNotFound = this.vm.isBillingAddressNotFound;

      data.businessTypeId = this.vm.businessTypeId;

      return this.permitSvc.updatePermit(data).toPromise().then((data1: PermitDetailsModel) => {
        this.permitSvc.model.permitDetails = data1.permitDetails;
        this.alertSvc.success(environment.TOASTR_HEADER, 'My account details were successfully updated', 2000, true);
      },
        (e) => {
          this.errorHandlingSvc.processHttpError(e);
        }).finally(() => { this.vm.isLoading = false; });
    }, () => { });
  }

  validate(): Promise<void> {
    this.vm.errors = [];

    this.validator.validateRequired('clientName', 'Business Name');
    this.validator.validateMaxLength('clientName', 'Business Name', 50);
    this.validator.validateRequired('firstName', 'First Name');
    this.validator.validateMaxLength('firstName', 'First Name', 50);
    this.validator.validateRequired('lastName', 'Last Name');
    this.validator.validateMaxLength('lastName', 'Last Name', 50);
    this.validator.validateCustom('abn', 'ABN must contain 11 digits or be empty',
                                    () => { return !(!this.vm.abn || this.vm.abn.match(/^(\d *?){11}$/)) });

    this.validator.validateRequired('email', 'Email');
    this.validator.validateEmail('email', 'Email');
    this.validator.validateMaxLength('email', 'Email', 50);
    this.validator.validateRequired('workPhone', 'Work Phone');
    this.validator.validatePhone('workPhone', 'Work Phone');
    this.validator.validateRequired('mobilePhone', 'Mobile Phone');
    this.validator.validateMobile('mobilePhone', 'Mobile Phone');

    this.validator.validateRequired('address1', 'Address Line 1');
    this.validator.validateMaxLength('address1', 'Address Line 1', 100);
    this.validator.validateMaxLength('address2', 'Address Line 2', 100);
    this.validator.validateRequired('suburb', 'Suburb');
    this.validator.validateMaxLength('suburb', 'Suburb', 50);
    this.validator.validateRequired('state', 'State');
    this.validator.validateState('state', 'State');
    this.validator.validateRequired('postCode', 'Postcode');
    this.validator.validateMaxLength('postCode', 'Postcode', 4);
    this.validator.validateMinLength('postCode', 'Postcode', 4);
    this.validator.validateCustom('postCode', 'Postcode must contain only numeric characters', () => {
      return !this.vm.postCode.match(/^\d+$/);
    });

    if (!this.vm.isSameAddress) {
      this.validator.validateRequired('billingAddress1', 'Address Line 1');
      this.validator.validateMaxLength('billingAddress1', 'Address Line 1', 100);
      this.validator.validateMaxLength('billingAddress2', 'Address Line 2', 100);
      this.validator.validateRequired('billingSuburb', 'Suburb');
      this.validator.validateMaxLength('billingSuburb', 'Suburb', 50);
      this.validator.validateRequired('billingState', 'State');
      this.validator.validateState('billingState', 'State');
      this.validator.validateRequired('billingPostCode', 'Postcode');
      this.validator.validateMaxLength('billingPostCode', 'Postcode', 4);
      this.validator.validateMinLength('billingPostCode', 'Postcode', 4);
      this.validator.validateCustom('billingPostCode', 'Postcode must contain only numeric characters', () => {
        return !this.vm.billingPostCode.match(/^\d+$/);
      });
    }

    this.validator.validateRequired('businessTypeId', 'Type of Business');
    if (this.vm.businessTypeId && this.vm.businessTypeId.toUpperCase() === '59BA4193-9F7B-48DE-B2C1-B7BD7D2D5AD1') {
      this.validator.validateRequired('businessTypeOther', 'Business Description');
    }

    if (this.vm.errors.length > 0) {
      return Promise.reject('Invalid Input');
    }

    return Promise.resolve();
  }

  public changePassword() {
    this.router.navigate(['/app/change-password']);
  }

  public clearBillingAddress() {
    this.vm.billingAddress1 = '';
    this.vm.billingAddress2 = '';
    this.vm.billingPostCode = '';
    this.vm.billingState = 'VIC';
    this.vm.billingSuburb = '';
  }

  public copyBusinessAddress() {
    this.vm.billingAddress1 = this.vm.address1;
    this.vm.billingAddress2 = this.vm.address2;
    this.vm.billingPostCode = this.vm.postCode;
    this.vm.billingState = this.vm.state;
    this.vm.billingSuburb = this.vm.suburb;
  }

  public updateBillingAddress() {
    if (!this.vm.isSameAddress) {
      return;
    }

    this.copyBusinessAddress();
  }

  public formatPhone(fieldName: string) {
    let value = this.vm[fieldName];
    if (value && value !== '' && !this.validator.failsAUPhone(value)) {
      this.vm[fieldName] = this.validator.formatPhone(value);
    }
  }

  public hasErrors() {
    return this.vm.errors.length > 0;
  }


  public addressNotFoundChanged() {
    if (this.vm.isAddressNotFound) {
      this.vm.addressSearch = '';
    }
  }

  public billingAddressNotFoundChanged() {
    if (this.vm.isBillingAddressNotFound) {
      this.vm.billingAddressSearch = '';
    }
  }

  public handleAddressChange(googleAddr: any) {

    let addr = this.googlePlacesSvc.toAddress(googleAddr);

    this.vm.address1 = addr.address1;
    this.vm.address2 = addr.address2;
    this.vm.suburb = addr.suburb;
    this.vm.state = addr.state;
    this.vm.postCode = addr.postCode;

    this.updateBillingAddress();
  }

  public handleBillingAddressChange(googleAddr: any) {

    let addr = this.googlePlacesSvc.toAddress(googleAddr);

    this.vm.billingAddress1 = addr.address1;
    this.vm.billingAddress2 = addr.address2;
    this.vm.billingSuburb = addr.suburb;
    this.vm.billingState = addr.state;
    this.vm.billingPostCode = addr.postCode;
  } 
}

export class AccountDetailsViewModel {

  constructor() {
    this.errors = [];
  }

  public isOpening: boolean;
  public isLoading: boolean;

  public permitId: string;
  public abn: string;

  public businessName: string;
  public contactName: string;
  public permitNo: string;
  public startDate: Date;

  public clientName: string;
  public firstName: string;
  public lastName: string;

  public isAddressNotFound: boolean;
  public addressSearch: string;
  public address1: string;
  public address2: string;
  public suburb: string;
  public state: string;
  public postCode: string;

  public isBillingAddressNotFound: boolean;
  public billingAddressSearch: string;
  public billingAddress1: string;
  public billingAddress2: string;
  public billingSuburb: string;
  public billingState: string;
  public billingPostCode: string;

  public email: string;
  public isEmailValidated: boolean;
  public mobilePhone: string;
  public workPhone: string;

  public businessTypeId: string;
  public businessTypeOther: string;
  public businessTypes: BusinessTypeListItemViewModel[];

  public status: string;
  public expiryDate: Date;

  public isSameAddress: boolean;
  public emsKeys: string[];
  public errors: ValidationError[];
}

export class BusinessTypeListItemViewModel {
  public businessTypeId: string;
  public description: string;
}
